import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumUllageStatus implements BaseEnumType {
  private static allValues: EnumUllageStatus[] = []; // make sure this is top-most
  
  public static unknown = new EnumUllageStatus(0, "Unknown", "enum_ullage_status_unknown");
  public static open = new EnumUllageStatus(1, "Open", "enum_ullage_status_open");
  public static completed = new EnumUllageStatus(2, "Completed", "enum_ullage_status_completed");
  public static cancelled = new EnumUllageStatus(5, "Cancelled", "enum_ullage_status_cancelled");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumUllageStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUnknown() { return this === EnumUllageStatus.unknown; }
  public isOpen() { return this === EnumUllageStatus.open; }
  public isCompleted() { return this === EnumUllageStatus.completed; }
  public isCancelled() { return this === EnumUllageStatus.cancelled; }

  public static getValues(): readonly EnumUllageStatus[] {
    return EnumUllageStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumUllageStatus[] {
    return EnumUllageStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumUllageStatus {
    const found = EnumUllageStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumUllageStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumUllageStatus): EnumUllageStatus {
    const found = name ? EnumUllageStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumUllageStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumUllageStatus>): boolean {
    return this.key === other?.key;
  }
}